import React from 'react'
import PropTypes from 'prop-types'
import { SkeletonTiles } from '../shared/SkeletonTiles'
import { getItemTypeConfig } from 'LiveBoard/components/shared/ItemType'
import { Description } from 'LiveBoard/components/mobile/shared/Item/Description'
import { SmartImage } from 'shared/UI/SmartImage'
import { DummyAnchorTag } from 'LiveBoard/components/shared/DummyAnchorTag'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const LeadingItem = ({
  config,
  themeColorHex,
  onClick,
  showItemDescription,
  leadingItemUrl
}) => {

  if(isEmpty(config)) {
    return <SkeletonTiles />
  }
  else {
    const itemTypeConfig = getItemTypeConfig(config)
    return (
      <section className="leading-item" onClick={onClick}>
        <div className="leading-item-image-wrapper">
          { itemTypeConfig.isVideo && <span className="icon-play-button" /> }
          <SmartImage config={config.image} />
        </div>
        <div className="description-container">
          <div className="description-text">
            <h1>
              <DummyAnchorTag url={leadingItemUrl}>{config.name}</DummyAnchorTag>
            </h1>
            { config.description && showItemDescription && (
              <Description text={config.description} themeColorHex={themeColorHex} />
            )}
          </div>
        </div>
      </section>
    )
  }
}

LeadingItem.propTypes = {
  config: PropTypes.object,
  themeColorHex: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showItemDescription: PropTypes.bool.isRequired,
  leadingItemUrl: PropTypes.string.isRequired
}

export default LeadingItem
